import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ProviderModel} from "../../../../models/provider.model";
import {GameService} from "../../../../services/game.service";
import {ActivatedRoute} from "@angular/router";
import {Game, Games} from "../../../../models/game.class";
import {Subscription} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {TitleService} from "../../../../services/title.service";


@Component({
  selector: 'app-selected-provider',
  templateUrl: './selected-provider.component.html',
  styleUrls: ['./selected-provider.component.scss'],
})
export class SelectedProviderComponent implements OnInit, OnDestroy {

  // TODO write a new error for providers not having games anymore - like not-found game and make different noGamesBlock

  readonly itemsPerPage = 24;

  routeSubs?: Subscription;
  chosenProvider!: string | null;
  providerSubs?: Subscription;
  provider?: ProviderModel;

  games?: Games;
  activeCategories: string[] = [];
  filteredGamesByCategory: Game[][] = []
  displayedGamesByCategory: Game[][] = []

  searchTerm = '';
  @ViewChildren('tab') tabs!: QueryList<ElementRef>

  selectedSorting: string = "POPULAR";
  resetBySortOrFilterNeeded: boolean = false; //the change of value marks to itemsShowCase child component that initial value needed (init, filter or sort)

  titleTranslateSubs?: Subscription;



  constructor(
    private gameService: GameService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private titleService: TitleService
  ) { }

  ngOnInit(): void {
    this.routeSubs?.unsubscribe();
    this.routeSubs = this.activatedRoute.params.subscribe(params => {

      this.chosenProvider = params['provider'];
      if (this.chosenProvider){
        //setting page title
        this.titleTranslateSubs?.unsubscribe();
        this.titleTranslateSubs = this.translate.stream('PROVIDERS.GAMES_TITLE').subscribe(data => {
          this.titleService.setTitle(`Lobby / ${data} ${this.chosenProvider}`);
        })

        // Resetting filters on route change
        this.searchTerm = '';
        this.selectedSorting = "POPULAR";
        if (this.tabs && this.tabs.length) {
          this.tabs.first.nativeElement.click();
        }

        //subscribe to publishers BS - this would change when logging in/out
        this.providerSubs?.unsubscribe();
        this.providerSubs = this.gameService.providers$.subscribe(providers => {
          // console.log(providers)
          const provider = providers.find(p=>p.routerLink === this.chosenProvider);
          // console.log('we have our provider:', provider?.name)
          if (provider){
            this.provider = provider
            this.games = Games.fromGameArray(this.provider.gameList);
            // console.log(this.games)
            // we will always have games as we filter publishers with games or we get them from a game list
            // but even if we dont get games, activeCategories and filteredGamesByCategory will be []

            this.activeCategories = this.gameService.getCategoriesWithGames(this.games);

            this.loadItems(undefined);

          } else {
            //we dont find provider anymore - ex. no games for that provider after log in - this.provider stays the previous available provider and values shown in template are reset
            this.games = undefined;
            this.activeCategories = []
            this.filteredGamesByCategory = []
          }
        })
      }
    });

  }

  onSearchChange(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.loadItems(undefined);
  }

  sortOptionSelected(value: string){
    this.selectedSorting = value;
    this.loadItems(undefined)
  }


  loadItems(itemsToShow: number | undefined) {
    //when itemsToShow is undefined, loadItems is called from parent, so initial itemsToShow value needed
    if (!itemsToShow){
      itemsToShow = this.itemsPerPage
    }
    if (itemsToShow === this.itemsPerPage){
      this.resetBySortOrFilterNeeded = !this.resetBySortOrFilterNeeded;
    }

    //filter by searchterm
    this.filterGames();
    // console.log(this.filteredGamesByCategory)

    //sort games - default: most played, enabled first on GP
    this.displayedGamesByCategory = this.filteredGamesByCategory.map(categorizedGames => {
      const result = Games.fromGameArray(categorizedGames).sortBy(this.selectedSorting)
      return result.slice(0, itemsToShow);
    })

  }

  filterGames() {
    //filter by searchTerm, if any - grouped by active categories
    const searchTerm = this.searchTerm?.trim().toLowerCase();
    this.filteredGamesByCategory = this.activeCategories.map(catName => {
      const gamesOfCategory = this.games?.getGamesOfCategory(catName) ?? [];
      return searchTerm
        ? gamesOfCategory.filter(game => game.name.toLowerCase().includes(searchTerm))
        : gamesOfCategory;
    });
  }


  //use placeholder when the provider image is not found
  updateNotFoundImgUrl(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/icons/providers.svg';
  }

  ngOnDestroy() {
    this.providerSubs?.unsubscribe();
    this.routeSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();
  }


}
